import z from "zod";

// NOTE: NSAI-6123 — the discriminated shape of `TCronSchedule`, for checking a
// row that came back from the API rather than trusting the declared type. `tz`
// and `anchorMs` accept `null` because stored rows carry it, and the interfaces
// admit `null` too so `isKnownCronSchedule` narrows to a type that matches what
// it actually accepted; the readers treat null as "omitted" already
// (`readScheduleTimezone`). Semantic validity (cron syntax, interval bounds,
// resolvable zone) is the server's job — this only decides whether the client
// may narrow on `kind` and read the fields.
export const cronScheduleSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("every"),
    everyMs: z.number().finite(),
    anchorMs: z.number().nullish(),
  }),
  z.object({
    kind: z.literal("at"),
    at: z.string(),
  }),
  z.object({
    kind: z.literal("cron"),
    expr: z.string(),
    tz: z.string().nullish(),
  }),
]);
